import type DayOfWeekIndexType from 'owa-service/lib/contract/DayOfWeekIndexType';
import { DAY_OF_WEEK_INDEX } from './constants';
import { getDate, DisplayDate } from 'owa-datetime';

// Given a date returns which week of the month the date is in.
// Eg. 01/01/2020 will return 'First' since it's in the first week of the month.
export default function getWeekOrder(startDate: DisplayDate): DayOfWeekIndexType {
    let dayOfMonth = getDate(startDate);
    let weekOrder = 0;

    while (dayOfMonth > 0) {
        dayOfMonth -= 7;
        ++weekOrder;
    }

    if (weekOrder > 0 && weekOrder < 5) {
        return DAY_OF_WEEK_INDEX[weekOrder];
    } else {
        return DAY_OF_WEEK_INDEX[5];
    }
}
